import React from 'react'
import AdminSettingsComponent from '../Components/AdminSettingsComponent'

function AdminSettingsPage() {
  return (
    <div>
      <AdminSettingsComponent />
    </div>
  )
}

export default AdminSettingsPage